import React from 'react';
import {Link} from 'react-router-dom';
import AurProgressBar from '../../../common/aur-progressbar/AurProgressBar';

const ProgressBar: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Progress Bar</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurProgressBar value={75} fileName="testfile.xlsx">
            <div>Cancel Upload</div>
          </AurProgressBar>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
